module.exports = __webpack_public_path__ + "img/mapa-mobile.5005236b.svg";